// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__2hZcM","active":"Loader_active__3nGTI","preloader":"Loader_preloader__1rv9_","centered":"Loader_centered__1nydA","small":"Loader_small__Sjxjf"};